import { Component, Input } from "@angular/core";

@Component({
    selector: "app-info-group",
    templateUrl: "./info-group.component.html",
    styleUrls: ["./info-group.component.scss"],
    standalone: false
})
export class InfoGroupComponent {
    @Input() headline: string = "";
    @Input() size: "small" | "medium" | "large" | "fit" = "medium";
}

@Component({
    selector: "app-info-group-body",
    template: `<ng-content></ng-content>`,
    standalone: false
})
export class InfoGroupBodyComponent {}
